var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#0197fe;opacity:0;}.b{fill:#0A186E;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 54,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 49
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.945,33a26.3,26.3,0,0,1-11.4-2.655A38.206,38.206,0,0,1,2.336,19.6c-.558-.685-1.09-1.409-1.605-2.109C.492,17.162.246,16.827,0,16.5v-.206c.029-.034.06-.067.091-.1a1.9,1.9,0,0,0,.173-.2A41.777,41.777,0,0,1,10.9,5.294,28.949,28.949,0,0,1,22.764.357c.6-.1,1.214-.176,1.807-.25.278-.034.565-.07.847-.108h3.164c.044.009.087.02.131.031a1.611,1.611,0,0,0,.277.053A26.473,26.473,0,0,1,39.074,2.94,39.63,39.63,0,0,1,53.652,15.963c.073.1.155.2.234.3.039.046.077.092.114.138V16.6c-.036.043-.072.086-.109.128a3.153,3.153,0,0,0-.212.263A40.54,40.54,0,0,1,40.991,29.017a27.525,27.525,0,0,1-12.709,3.948C27.837,32.988,27.387,33,26.945,33ZM27.1,3.263h0a24.584,24.584,0,0,0-8.072,1.411C13.24,6.685,8.461,10.448,4.414,16.182c-.22.311-.087.5.067.724a32.127,32.127,0,0,0,6.9,7.254A25.361,25.361,0,0,0,26.875,29.7a23.847,23.847,0,0,0,7.954-1.313A30.066,30.066,0,0,0,49.559,16.862a.561.561,0,0,0-.037-.769A31.117,31.117,0,0,0,38.94,6.439,24.581,24.581,0,0,0,27.1,3.264ZM27,26.4h0a10.026,10.026,0,0,1-10.125-9.9A10.127,10.127,0,0,1,37.124,16.5a9.725,9.725,0,0,1-2.965,7A10.166,10.166,0,0,1,27,26.4ZM27,9.437h-.009a7.251,7.251,0,0,0-5.1,2.07,6.945,6.945,0,0,0-2.114,5A7.154,7.154,0,0,0,27,23.565a7.256,7.256,0,0,0,5.108-2.073,6.938,6.938,0,0,0,2.116-5A7.154,7.154,0,0,0,27,9.437Z",
    transform: "translate(0 9)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-view.a4363b11bb7f53bca9da917d4786d746.svg";